import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import Home from '../containers/Home';
import SimpleSectionPereira from '../containers/SimpleSectionPereira';
import SimpleSectionBogota from '../containers/SimpleSectionBogota';
import SimpleSectionAntioquia from '../containers/SimpleSectionAntioquia';
import SimpleSection from '../containers/SimpleSection';
import ContactGeneral from '../containers/ContactGeneral';
import BookNow from '../containers/BookNow';
import CheckRegisterInfo from '../containers/CheckRegisterInfo';
import ConfirmationPage from '../containers/ConfirmationPage';

const App = () => (
  <BrowserRouter basename="/adventures">
    <Switch>
      <Route exact path="/" component={Home} />
      <Route exact path="/coffee-mtb/itinerary/:slug" render={(props) => <SimpleSectionPereira {...props} itinerary={true} />} />
      <Route exact path="/coffee-mtb/:slug" render={(props) => <SimpleSectionPereira {...props} itinerary={false} />} />
      <Route exact path="/volcano-mtb/itinerary/:slug" render={(props) => <SimpleSectionBogota {...props} itinerary={true} />} />
      <Route exact path="/volcano-mtb/:slug" render={(props) => <SimpleSectionBogota {...props} itinerary={false} />} />
      <Route exact path="/antioquia-mtb/itinerary/:slug" render={(props) => <SimpleSectionAntioquia {...props} itinerary={true} />} />
      <Route exact path="/antioquia-mtb/:slug" render={(props) => <SimpleSectionAntioquia {...props} itinerary={false} />} />
      <Route exact path="/contact-us" component={ContactGeneral} />
      <Route exact path="/booknow/:slug" component={BookNow} />
      <Route exact path="/check-info" component={CheckRegisterInfo} />
      <Route exact path="/confirmation-page" component={ConfirmationPage} />
      <Route exact path="/:slug" component={SimpleSection} />
    </Switch>
  </BrowserRouter>
);

export default App;
